import type { TocSlide, TocTree } from '../models/toc.model';

/** Insert generated figure slides into in-memory TOC after the parent slide. */
export function mergeInsertedTocSlides(
  toc: TocTree | null | undefined,
  afterSlideId: string,
  inserted: TocSlide[] | null | undefined,
): number {
  if (!toc?.sections?.length || !inserted?.length) return 0;
  const parentId = String(afterSlideId || '').trim();
  if (!parentId) return 0;

  for (const section of toc.sections) {
    const slides = section.slides;
    if (!slides?.length) continue;
    const idx = slides.findIndex((s) => String(s.slideId) === parentId);
    if (idx < 0) continue;
    const toAdd = inserted.map((s) => ({
      slideId: s.slideId,
      title: s.title || '',
      description: s.description || '',
      status: (s.status || 'FILLED') as TocSlide['status'],
      ...(s.sourcePageRef ? { sourcePageRef: s.sourcePageRef } : {}),
      ...(s.slideType ? { slideType: s.slideType } : {}),
    }));
    slides.splice(idx + 1, 0, ...toAdd);
    return toAdd.length;
  }
  return 0;
}
